import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["percentage", "size", "breakpoints", "inverted", "shady", "square", "children"];
import "core-js/modules/es.string.big.js";
import React, { forwardRef } from 'react';
import Text from 'components/Text';
import Box from 'components/Box';
import { Disc, Wrapper } from 'components/IconDisc';
import { scalePresets } from 'components/CircleImage';
var PercentageDisc = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var percentage = _ref.percentage,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    breakpoints = _ref.breakpoints,
    inverted = _ref.inverted,
    shady = _ref.shady,
    square = _ref.square,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeOverrideProps = scalePresets.big;
  var isBig = size === 'big';
  var fontSize = isBig ? 'xl' : 'xxs';
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(Disc, _extends({}, sizeOverrideProps, {
    inverted: inverted,
    shady: shady,
    square: square,
    scale: isBig ? 2 : 1
  }), /*#__PURE__*/React.createElement(Box, {
    pb: isBig ? 'xs' : 'xxxs'
  }, percentage || percentage === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: fontSize
  }, percentage), /*#__PURE__*/React.createElement(Text, {
    fontSize: "xxxs"
  }, "%")) : /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: fontSize
  }, "-"))));
});
PercentageDisc.displayName = 'PercentageDisc';
export default PercentageDisc;